/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { CheckedIcon, Text } from "src/shared"

interface ShopSelectItemProps {
  data: any
  isChecked?: boolean
}

const ShopSelectItem = ({ data, isChecked = false }: ShopSelectItemProps) => {
  return (
    <Grid
      columnGap={4}
      justifyContent="space-between"
      alignItems="center"
      container
      flexWrap="nowrap"
    >
      <Grid
        item
        sx={{
          [theme.breakpoints.down(500)]: {
            fontSize: 14,
            lineHeight: "18px",
          },
        }}
      >
        <Text
          lineHeight="21px"
          color={theme.palette.common.black}
          fontSize={16}
        >
          {data.StoreName}
        </Text>
        <Text
          lineHeight="21px"
          color={theme.palette.grey[400]}
          fontSize={16}
          sx={{
            wordBreak: "break-word",
            whiteSpace: "initial",
          }}
        >
          {data.Address}
        </Text>
      </Grid>
      <Grid item alignSelf="flex-end">
        <CheckedIcon
          sx={{
            "& circle": {
              fill: isChecked
                ? theme.palette.info.main
                : theme.palette.grey[400],
            },
          }}
        />
      </Grid>
    </Grid>
  )
}

export default ShopSelectItem
